export default "__VITE_ASSET__f4ddbb6c__"